var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfilLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 73,
  viewBox: "0 0 55 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.5009 45.469C12.3137 45.469 0 57.7808 0 72.9699H55C55 57.7826 42.6881 45.469 27.4991 45.469H27.5009Z",
  fill: "#D20071"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.501 36.5702C37.5996 36.5702 45.7861 28.3837 45.7861 18.2851C45.7861 8.18652 37.5996 0 27.501 0C17.4024 0 9.21582 8.18652 9.21582 18.2851C9.21582 28.3837 17.4024 36.5702 27.501 36.5702Z",
  fill: "#D20071"
})));
export default SvgProfilLarge;